__webpack_require__.p = "/weglide_slideshow/";